import { render, staticRenderFns } from "./free-ecard.vue?vue&type=template&id=526acdbf&scoped=true"
import script from "./free-ecard.vue?vue&type=script&lang=js"
export * from "./free-ecard.vue?vue&type=script&lang=js"
import style0 from "./free-ecard.vue?vue&type=style&index=0&id=526acdbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526acdbf",
  null
  
)

export default component.exports